export default __webpack_public_path__ + "static/planet-36d5beffeee164c4a328a4791d0bb636.png";